import { styled } from '@sds-system/system';
import { getAllStyledProps } from '@sds-system/utils';
import type { ToggleSwitchHandlerStyledProps, ToggleSwitchRootStyledProps } from '..';

export const StyledToggleSwitchRoot = styled('label')<ToggleSwitchRootStyledProps>(
  ({ theme, height }) => ({
    display: 'flex',
    width: '46px',
    height: '24px',
    borderRadius: height
      ? `calc(${typeof height === 'string' ? height : height + 'px'} / 2)`
      : '12px',
    padding: '2px',
    backgroundColor: theme.palette.bg.disabledDark,
    cursor: 'pointer',
    variants: [
      {
        props: { checked: true },
        style: {
          backgroundColor: theme.palette.icon.interactive.primary,
        },
      },
      {
        props: { disabled: true },
        style: {
          backgroundColor: theme.palette.bg.disabledDark,
          cursor: 'not-allowed',
        },
      },
      {
        props: { size: 'M' },
        style: {
          width: '46px',
          height: '24px',
        },
      },
      {
        props: { size: 'S' },
        style: {
          width: '42px',
          height: '20px',
        },
      },
    ],
  }),
  ...getAllStyledProps,
);

export const StyledToggleSwitchHandler = styled('div')<ToggleSwitchHandlerStyledProps>(
  ({ theme }) => ({
    display: 'block',
    backgroundColor: theme.palette.icon.interactive.inverse,
    height: '100%',
    aspectRatio: 1 / 1,
    borderRadius: '50%',
    boxShadow: theme.shadow.center.normal,
    transition: 'all 0.3s ease-in',
    variants: [
      {
        props: { checked: true },
        style: {
          marginLeft: '100%',
          transform: 'translate(-100%)',
        },
      },
      {
        props: { disabled: true },
        style: {
          backgroundColor: theme.palette.gray[200],
          cursor: 'not-allowed',
        },
      },
    ],
  }),

  ...getAllStyledProps,
);
